import { 
    MODIFICA_EMAIL, 
    MODIFICA_SENHA, 
    MODIFICA_NOME, 
    MODIFICA_LOGIN, 
    CADASTRO_USUARIO_ERRO, 
    LOGIN_USUARIO_SUCESSO, 
    LOGIN_USUARIO_ERRO,
    LOGIN_EM_ANDAMENTO,
    LOGOUT,
    CADASTRO_EM_ANDAMENTO
 } from '../actions/types';

const INITIAL_STATE = {
    token: '',
    name: '',
    email: '',
    login: '',
    senha: '',
    c_agent_id: '', 
    empresa_id: '', 
    empresa_uid: '', 
    employee: '',
    authenticated: false,
    errorCadastro: '',
    errorLogin: '',
    loadingLogin: false,
    loadingCadastro: false,
    listQueues: 1,
    queuesAvaliable: [],
    statusAvaliable: []
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MODIFICA_EMAIL:
            return { ...state, email: action.payload }
        case MODIFICA_LOGIN:
            return { ...state, login: action.payload }
        case MODIFICA_SENHA:
            return { ...state, senha: action.payload }
        case MODIFICA_NOME:
            return { ...state, nome: action.payload }
        // case CADASTRO_USUARIO_ERRO:
        //     return { ...state, errorCadastro: action.payload }
        case LOGIN_USUARIO_SUCESSO:
            return { ...state, ...action.payload }
        // case LOGIN_USUARIO_ERRO:
        //     return { ...state, errorLogin: action.payload }
        // case LOGIN_EM_ANDAMENTO:
        //     return { ...state, loadingLogin: action.payload }
        // case CADASTRO_EM_ANDAMENTO:
        //     return { ...state, loadingCadastro: action.payload }
        case LOGOUT:
            return { ...state, ...INITIAL_STATE }
        default:
            return state;   
    }
}